module.exports = __webpack_public_path__ + "img/add_to_cart.59e2a6fc.svg";